import { useEffect, useLayoutEffect, useState } from 'react';

import { formatNumber } from '../../../../utils/numberFormat';
import { getIntegerProgress } from '../../utils';

export type UseProgressBarArgs = {
  current: number;
  max: number;
  onAnimationStart?: () => void;
  onAnimationEnd?: () => void;
  disableAnimation?: boolean;
  integerProgress?: boolean;
  missionId?: string;
};
const TOTAL_ANIMATION_STEPS = 50;
const STEP_INTERVAL = 20;

export const useProgressBar = ({
  current,
  max,
  disableAnimation,
  integerProgress,
  onAnimationEnd,
  onAnimationStart,
  missionId,
}: UseProgressBarArgs) => {
  const [progress, setProgress] = useState(0);

  useLayoutEffect(() => {
    setProgress(0);
  }, [max, missionId]);

  useEffect(() => {
    if (disableAnimation) return;
    if (current > max) {
      setProgress(max);
      return;
    }
    onAnimationStart?.();
    const step = current / TOTAL_ANIMATION_STEPS;
    const interval = setInterval(() => {
      if (progress < current) {
        let next = progress + step;
        if (next > current) {
          next = current;
        }
        setProgress(next);
      } else {
        onAnimationEnd?.();
        clearInterval(interval);
        return;
      }
    }, STEP_INTERVAL);

    return () => clearInterval(interval);
  }, [current, progress, max, onAnimationEnd, onAnimationStart, disableAnimation]);

  const progressDisplay = integerProgress ? getIntegerProgress(progress) : formatNumber(progress);

  return { progress, progressDisplay };
};
